const Badge = ({
  children,
  color = "gray",
  size = "sm",
  className = "",
  ...props
}) => {
  const baseClasses = "inline-flex items-center font-medium rounded-full";

  const colors = {
    gray: "bg-gray-100 text-gray-800",
    blue: "bg-blue-100 text-blue-800",
    green: "bg-green-100 text-green-800",
    yellow: "bg-yellow-100 text-yellow-800",
    red: "bg-red-100 text-red-800",
    teal: "bg-teal-100 text-teal-800",
    gold: "bg-yellow-200 text-yellow-900",
    silver: "bg-gray-200 text-gray-900",
    bronze: "bg-orange-200 text-orange-900",
  };

  const sizes = {
    xs: "px-2 py-0.5 text-xs",
    sm: "px-2.5 py-0.5 text-xs",
    md: "px-3 py-1 text-sm",
    lg: "px-4 py-1 text-sm",
  };

  const classes = `${baseClasses} ${colors[color]} ${sizes[size]} ${className}`;

  return (
    <span className={classes} {...props}>
      {children}
    </span>
  );
};

export default Badge;
